module.exports = __webpack_public_path__ + "img/UNGapDetails-min.471fbf97.png";